import React, {useMemo} from 'react'
import {CouponQueueDetailDto, MerchantDto} from 'rest'
import {parseCouponTitle} from 'utils/coupon.utils'
import {OfferBadge} from 'components/template/OfferBadge'
import APP_CONFIG from 'constants/clientConfigs'
import {twMerge} from 'tailwind-merge'

const {currencySymbol, infoBg} = APP_CONFIG[process.env.REACT_APP_CLIENT_ID]

interface Props {
  merchant: MerchantDto
  coupon: CouponQueueDetailDto
  showMerchantLink?: boolean
  currency?: string
  className?: string
  /* header visibility */
  header?: boolean
  /* button visibility */
  button?: boolean
  currentSavingsRange: boolean
}

export const CardCoupon = ({
  merchant,
  coupon,
  // showMerchantLink = true,
  currency = currencySymbol,
  className: _className = '',
  // header = true,
  button = true,
  currentSavingsRange,
}: Props) => {
  console.log('infoBg', infoBg)
  const [prefix, title, suffix, className] = useMemo(
    () => parseCouponTitle({...coupon, isSavingsRange: currentSavingsRange}),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [currentSavingsRange, coupon.typeId, coupon.savings, currency]
  )

  return (
    <div className={`coupon ${_className}`}>
      {merchant?.logo_url && (
        <header className="header">
          <a
            href={merchant?.url}
            target="_blank"
            rel="noreferrer"
            className="logo">
            <img
              src={String(merchant?.logo_url)}
              alt={String(merchant?.name)}
              width={120}
              height={40}
            />
          </a>
        </header>
      )}
      <a href={merchant?.url} className="name" target="_blank" rel="noreferrer">
        {String(merchant?.name)}
      </a>
      <div className="offers">
        <OfferBadge
          prefix={prefix}
          title={title}
          suffix={suffix}
          className={className}
        />
      </div>

      <p className="description">{coupon.description}</p>

      {button && (
        <button
          className={twMerge(
            'button font-semibold flex items-center text-sm justify-center fill-white',
            infoBg
          )}
          onClick={() => window.open(coupon.destinationUrl, '_blank')}>
          Use Coupon{' '}
          <svg
            width="14"
            height="8"
            viewBox="0 0 14 8"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M8.83432 0.234315C9.14674 -0.0781049 9.65327 -0.0781049 9.96569 0.234315L13.1657 3.43431C13.4781 3.74673 13.4781 4.25327 13.1657 4.56569L9.96569 7.76569C9.65327 8.0781 9.14674 8.0781 8.83432 7.76569C8.5219 7.45327 8.5219 6.94673 8.83432 6.63432L10.6686 4.8H1.40001C0.958179 4.8 0.600006 4.44183 0.600006 4C0.600006 3.55817 0.958179 3.2 1.40001 3.2H10.6686L8.83432 1.36569C8.5219 1.05327 8.5219 0.546734 8.83432 0.234315Z" />
          </svg>
        </button>
      )}
    </div>
  )
}
